module.exports = __webpack_public_path__ + "static/img/pinky.f408412.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/drawing/pinky.jpg
// module id = Lazi
// module chunks = 1